export default {
	'文本描述': '文本描述',
	'单选': '單選',
	"多选": "多選",
	"填空": "填空",
	"问答": "問答",
	"量表": "量表",
	"矩阵单选": "矩陣單選",
	"矩阵多选": "矩陣多選",
	"矩阵量表": "矩陣量表",
	"排序": "排序",
	"表格填空": "表格填空",
	"附件上传": "附件上傳",
  "附件":"附件",
	"表格下拉(单选)": "表格下拉(單選)",
	"表格下拉": "表格下拉",
	"定位": "定位",
	"划线": "劃綫",
	"矩阵限时判断": "矩陣限時判斷",
	"日历": "日曆",
	"满意度": '滿意度',
	"认同度": '認同度',
	"重要度": '重要度',
	"愿意度": '願意度',
	"符合度": '符合度',
	"自定义": '自訂',
	"自定义文字": '自訂文字',
	"默认": '默認',
	"滑块": '滑塊',
	"大拇指": '大拇指',
	"笑脸": '笑臉',
	"星星": '星星',
	"笑脸哭脸": '笑臉/哭臉',
	"勾叉": '勾/叉',
	"满意": '滿意',
	"认同": '認同',
	"重要": '重要',
	"愿意": '願意',
	"符合": '符合',
  "手写签名":"手寫簽名",
  "联动":'聯動',
  "标注":'標注'
}